'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ColumnGroup = function (_React$Component) {
  (0, _inherits3['default'])(ColumnGroup, _React$Component);

  function ColumnGroup() {
    (0, _classCallCheck3['default'])(this, ColumnGroup);
    return (0, _possibleConstructorReturn3['default'])(this, (ColumnGroup.__proto__ || Object.getPrototypeOf(ColumnGroup)).apply(this, arguments));
  }

  return ColumnGroup;
}(_react2['default'].Component);

exports['default'] = ColumnGroup;

ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/table/ColumnGroup.js
// module id = ld86
// module chunks = 0